import { generateUtilityClasses } from "@mui/material";
const editorName = "TidalEditor";
const editorClasses = generateUtilityClasses(editorName, [
  "root",
  "footer",
  "footerDisabled",
  "toolbar",
  "toolbar",
  "toolbarError",
  "quickInsertToolbar",
  "editorScroller",
  "editorScrollerDisabled",
  "helperText",
  "placeholder",
  "editorContent",
  "editorContentError",
  "contentEditable",
  "contentEditableDisabled",
  "actionContainer",
  "bottomToolbar"
]);
export {
  editorClasses,
  editorName
};
//# sourceMappingURL=classes.js.map
